import React, { useMemo } from "react";
import Lifestyle1 from "../../../assets/lifestyle-1.jpg";
import Lifestyle2 from "../../../assets/lifestyle-2.jpg";
import Lifestyle4 from "../../../assets/lifestyle-4.jpg";
import Lifestyle5 from "../../../assets/lifestyle-5.jpg";
import Lifestyle6 from "../../../assets/lifestyle-6.jpg";
import Lifestyle7 from "../../../assets/lifestyle-7.jpg";
import Lifestyle8 from "../../../assets/lifestyle-8.jpg";

const fallbackImages = [
  Lifestyle1,
  Lifestyle2,
  Lifestyle4,
  Lifestyle5,
  Lifestyle6,
  Lifestyle7,
  Lifestyle8,
];

function LifestyleSection({ laguna_creek_lifestyle }) {
  const defaultTitle = "Laguna Creek Lifestyle";

  const lifestyle_gallery = useMemo(() => {
    return laguna_creek_lifestyle?.lifestyle_gallery ?? [];
  }, [laguna_creek_lifestyle]);

  const title = laguna_creek_lifestyle?.lifestyle_title || defaultTitle;

  const lifestyle_gallery_html = useMemo(() => {
    return lifestyle_gallery.map((a, i) => {
      const fallbackImage = fallbackImages[i % fallbackImages.length];
      return (
        <img
          key={i}
          src={a?.img || fallbackImage}
          alt={"Lifestyle " + i}
          className="rounded-[21px]"
          height="1416"
          width="483"
        />
      );
    });
  }, [lifestyle_gallery]);

  return (
    <>
      <section className="py-10 md:py-16 flex flex-col gap-y-8 bg-gradient-to-r from-[rgba(255,255,255,0)] to-[#F7F7F7] overflow-hidden">
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full max-w-full px-4">
              <h2
                className={`text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-none text-[#5fa3b2] text-center`}
              >
                {title}
              </h2>
            </div>
          </div>
        </div>
        <div className="w-full max-w-full px-4 mx-auto">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full max-w-full">
              <div className="flex flex-col gap-[10px]">
                <div className="marquee">
                  <div className="marquee__group">
                    {lifestyle_gallery_html}
                    {/* <img
                      src={Lifestyle1}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle2}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle4}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle5}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle6}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle7}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle8}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    /> */}
                  </div>
                  <div aria-hidden="true" className="marquee__group">
                    {lifestyle_gallery_html}
                    {/* <img
                      src={Lifestyle1}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle2}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle4}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle5}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle6}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle7}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle8}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    /> */}
                  </div>
                </div>
                <div className="marquee marquee--reverse">
                  <div className="marquee__group">
                    {lifestyle_gallery_html}
                    {/* <img
                      src={Lifestyle1}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle2}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle4}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle5}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle6}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle7}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle8}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    /> */}
                  </div>
                  <div aria-hidden="true" className="marquee__group">
                    {lifestyle_gallery_html}
                    {/* <img
                      src={Lifestyle1}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle2}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle4}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle5}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle6}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle7}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    />
                    <img
                      src={Lifestyle8}
                      alt="Lifestyle"
                      className="rounded-[21px]"
                      height="1416"
                      width="483"
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default LifestyleSection;
